import { render, staticRenderFns } from "./ConnectAccount.vue?vue&type=template&id=305460a4&scoped=true&"
import script from "./ConnectAccount.vue?vue&type=script&lang=js&"
export * from "./ConnectAccount.vue?vue&type=script&lang=js&"
import style0 from "./ConnectAccount.vue?vue&type=style&index=0&id=305460a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305460a4",
  null
  
)

export default component.exports